export const PHOTOS_SET_COLLECTIONS = 'PHOTOS_SET_COLLECTIONS';
export const PHOTOS_CHECK_COLLECTION = 'PHOTOS_CHECK_COLLECTION';
export const PHOTOS_CHECK_ENTRY = 'PHOTOS_CHECK_ENTRY';
export const PHOTOS_CLEAR_CHECKED_COLLECTIONS = 'PHOTOS_CLEAR_CHECKED_COLLECTIONS';
export const PHOTOS_CLEAR_CHECKED_ENTRIES = 'PHOTOS_CLEAR_CHECKED_ENTRIES';
export const PHOTOS_DID_LOAD = 'PHOTOS_DID_LOAD';
export const PHOTOS_TOGGLE_GALLERY_VIEW = 'PHOTOS_TOGGLE_GALLERY_VIEW';
export const PHOTOS_CLEAR_DATA = 'PHOTOS_CLEAR_DATA';
